define(function () {
    var validation = {
        observable: function (init) {
            var observable = ko.observable(init);
            observable.error = ko.observable();
            observable.focus = ko.observable(false);
            observable.valid = ko.computed(function () {
                if (observable.error()) {
                    return false;
                }
                return true;
            });
            observable.subscribe(function () {
                observable.error("");
            });
            return observable;
        },
        observableArray: function (init) {
            var observable = ko.observableArray(init);
            observable.error = ko.observable();
            for (var i = 0; i > observable.length; i++) {
                observable[i].focus = ko.observable(false);
                observable[i].valid = ko.computed(function () {
                    if (observable.error()) {
                        return false;
                    }
                    return true;
                });
            }
            observable.valid = ko.computed(function () {
                if (observable.error()) {
                    return false;
                }
                return true;
            });
            observable.subscribe(function () {
                observable.error("");
            });
            return observable;
        },
        unwrapValues: function (fields) {
            var unwrapped = {};
            Object.keys(fields).forEach(function (field) {
                unwrapped[field] = ko.utils.unwrapObservable(fields[field]);
            });

            return unwrapped;
        },
        mapErrors: function (validations, fields) {
            var valid = true;
            function mapToCamelCaseObject(obj) {
                var newObj = {};
                Object.entries(obj).forEach(function (entry) {
                    const [key, value] = entry;
                    newObj[key.charAt(0).toLowerCase() + key.slice(1)] =
                        obj[key];
                });
                return newObj;
            }

            Object.keys(fields).forEach(function (field) {
                var observable = fields[field];
                if (
                    observable &&
                    ko.isObservable(observable.error) &&
                    observable.error()
                ) {
                    observable.error("");
                }
            });

            validations.forEach(function (validateField) {
                // TODO: map to camelCaseObject until everyone will switch to JsonCamelCaseResult.
                var field = mapToCamelCaseObject(validateField);
                if (field && field.propertyName) {
                    var observable = fields[field.propertyName];
                    if (observable && ko.isObservable(observable.error)) {
                        observable.error("");
                        if (field.errors.length > 0) {
                            observable.error(field.errors[0]);

                            if (valid) {
                                observable.focus(true);
                            }
                            valid = false;
                        }
                    }
                }
            });
            return valid;
        },
    };

    return validation;
});
